import Cookies from "js-cookie";  

const setCookie = (key, value) => Cookies.set(key, value, { expires: 7, path: "/" });
const getCookie = (key) =>  Cookies.get(key);
const removeCookie = (key) => Cookies.remove(key, { expires: 7 });

export { setCookie, getCookie, removeCookie };

